import AutocompleteFormFieldAPI from './autocomplete_form_field_api';

/**
 * @class RadioFormFieldAPI
 * @extends AutocompleteFormFieldAPI
 */
class RadioFormFieldAPI extends AutocompleteFormFieldAPI {

	/**
	 * @constructor
	 * @param {*} param0
	 */
	constructor({ id, storeId, formId, gridId, applyMode, isGridField = false }) {
		super({ id, storeId, formId, gridId, applyMode, isGridField });
	}
}

export default RadioFormFieldAPI;

